import { render, staticRenderFns } from "./SponsorReportSection.vue?vue&type=template&id=0cdbce32&scoped=true"
import script from "./SponsorReportSection.vue?vue&type=script&lang=js"
export * from "./SponsorReportSection.vue?vue&type=script&lang=js"
import style0 from "./SponsorReportSection.vue?vue&type=style&index=0&id=0cdbce32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdbce32",
  null
  
)

export default component.exports